import { sumBy } from 'lodash'
import { BD_TRANSANCTION_INFO } from '../config/bdTransactionInfoKeys'
// Add up participants plan summary data (used in ARO participant file flow)
// summaryData has the following shape: [ { planName: /string/, participants: /number/, traditionalIraPreTaxAmount: /number/,
// traditionalIraAfterTaxAmount: /number/, rothIraAmount: /number/ } ]
function sumUpParticipantsSummaryData(summaryData) {
  return {
    totalPlans: summaryData.length,
    totalParticipants: sumBy(summaryData, 'participants'),
    [BD_TRANSANCTION_INFO.AMOUNT]: sumBy(
      summaryData,
      BD_TRANSANCTION_INFO.AMOUNT
    ),
    [BD_TRANSANCTION_INFO.INSPIRA_BD_PROCESSING_FEE]: sumBy(
      summaryData,
      BD_TRANSANCTION_INFO.INSPIRA_BD_PROCESSING_FEE
    ),
    [BD_TRANSANCTION_INFO.TPA_BD_PROCESSING_FEE]: sumBy(
      summaryData,
      BD_TRANSANCTION_INFO.TPA_BD_PROCESSING_FEE
    ),
    [BD_TRANSANCTION_INFO.GROSS_DISTRIBUTION_AMOUNT]: sumBy(
      summaryData,
      BD_TRANSANCTION_INFO.GROSS_DISTRIBUTION_AMOUNT
    ),
  }
}

export default sumUpParticipantsSummaryData
